export const environment = {
  production: false,
  RUC: '00000000003',
  API_URL_CONFIG: '/backend-config',
  API_URL_LOGIN: '/backend-login',
  API_URL_AI_EXPLAINER: '/formula-explainer',
  API_URL_AI_DOCUMENT:  '/scanner-document',
  API_URL_AI_REWRITER:  '/support-rewriter',
};
